import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginModule } from './login';
import { MaterialModule } from 'libs/shared-third-party/src/lib/material/material.module';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

@NgModule({
    declarations: [PageNotFoundComponent],
    imports: [
        CommonModule,
        LoginModule,
        MaterialModule,
        RouterModule
    ],
    exports: [LoginModule, PageNotFoundComponent],
})
export class CommonPagesModule {}

